import {
  BNPL_MAX_TRANSACTION_UNIT_AMOUNT,
  BNPL_MIN_TRANSACTION_UNIT_AMOUNT,
} from 'constants/bnpl';
import numeral from 'numeral';

import { convertDecimalToSubunits } from './payments/money';

/**
 * Get the BNPL unit price from a string in dollars
 * @param price - The price to get the BNPL unit price from
 * @returns The BNPL unit price or undefined if it's not within the range
 */
export const getBnplUnitPriceFromStringDollars = (price: string) => {
  const priceNumber = numeral(price).value() ?? 0;

  const unitPrice = convertDecimalToSubunits(priceNumber);
  const withinRange =
    unitPrice >= BNPL_MIN_TRANSACTION_UNIT_AMOUNT &&
    unitPrice <= BNPL_MAX_TRANSACTION_UNIT_AMOUNT;

  return withinRange ? unitPrice : undefined;
};
